import React from 'react';

import './TableOcc.scss';
import { useIntl } from 'react-intl';
import { formatOPN } from '../../../../../../utils/helpers';

// export const columnHeadersText = [
//   { key: 'a', element: <>STAGE</> },
//   {
//     key: 'b',
//     element: (
//       <>
//         OCCs
//         <br />
//         ISSUED
//       </>
//     ),
//   },
//   {
//     key: 'c',
//     element: (
//       <>
//         OCCs
//         <br />
//         RECEIVED
//       </>
//     ),
//   },
//   {
//     key: 'd',
//     element: (
//       <>
//         OCCs
//         <br />
//         FOR BUFFER POOL
//       </>
//     ),
//   },
//   {
//     key: 'e',
//     element: (
//       <>
//         OCCs
//         <br />
//         FOR ECOSYSTEM
//       </>
//     ),
//   },
// ];

const TableOcc = ({ data }) => {
  const translate = useIntl();

  const columnHeadersText = [
    { key: 'a', element: <>{translate.formatMessage({ id: 'carbon.form.tableFive' })}</> },
    {
      key: 'b',
      element: (
        <>
          OCCs
          <br />
          {translate.formatMessage({ id: 'carbon.form.tableSix' })}
        </>
      ),
    },
    {
      key: 'c',
      element: (
        <>
          OCCs
          <br />
          {translate.formatMessage({ id: 'carbon.form.tableSeven' })}
        </>
      ),
    },
    {
      key: 'd',
      element: (
        <>
          OCCs
          <br />
          {translate.formatMessage({ id: 'carbon.form.tableEight' })}
          {' '}

        </>
      ),
    },
    {
      key: 'e',
      element: (
        <>
          OCCs
          <br />
          {translate.formatMessage({ id: 'carbon.form.tableNine' })}
          {' '}

        </>
      ),
    },
  ];

  return (
    <table className="tableOcc">
      <thead className="tableOcc__head">
        <tr>
          {columnHeadersText.map(({ element, key }) => (
            <th key={key} className="tableOcc__headItem">{element}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(
          ({
            // eslint-disable-next-line camelcase
            stage_id, stage_date, project_operator_rewards, buffer_pool_rewards, validation_pool_rewards, planting_pool_rewards,
          }) => {
            // eslint-disable-next-line camelcase
            const stage = (+stage_id + 1).toString();

            return (
            // eslint-disable-next-line camelcase
              <tr className="tableOcc__row" key={stage_id}>
                <td className="tableOcc__cell">
                  <span className="tableOcc__number">
                    {translate.formatMessage({ id: 'carbon.form.tableFive' })}
                    {' '}
                    {stage}
                  </span>
                  <span className="tableOcc__date">
                    (
                    {/* eslint-disable-next-line camelcase */}
                    {stage_date}
                    )
                  </span>
                </td>
                <td className="tableOcc__cell">
                  {formatOPN(
                    BigInt(project_operator_rewards)
                                    + BigInt(buffer_pool_rewards)
                                    + BigInt(validation_pool_rewards)
                                    + BigInt(planting_pool_rewards),
                    3,
                  )}
                </td>
                <td className="tableOcc__cell">
                  {formatOPN(project_operator_rewards, 3)}
                </td>
                <td className="tableOcc__cell">
                  {formatOPN(buffer_pool_rewards, 3)}
                </td>
                <td className="tableOcc__cell">
                  {formatOPN(
                    BigInt(validation_pool_rewards)
                                    + BigInt(planting_pool_rewards),
                    3,
                  )}
                </td>
              </tr>
            );
          },
        )}
      </tbody>
    </table>
  );
};

export default TableOcc;
